export default __webpack_public_path__ + "static/media/Q22021.af33a178.PDF";